import CryptoJS from "crypto-js";
import { AppConstant } from "../config/AppConstants";
import { refreshAuthToken } from "../api/tokenRefresh";
import { syncHasEmergencyRolesFromPayload } from "../utils/SecurityService.js";
/* eslint-disable eqeqeq */
// import { get } from "jquery";
// import * as authMemory from '../services/authMemory';
// Login with email and password
export const LoginWithPassword = async (email, password) => {
  // Hash password as in your commented code
  const PasswordT = CryptoJS.MD5(password).toString(CryptoJS.enc.Hex);
  const PasswordN = CryptoJS.SHA512(password).toString(CryptoJS.enc.Hex);
  const response = await fetch(User_login_api, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      PrimaryEmail: email,
      PasswordT,
      PasswordN,
      ManufactureModel: "react",
      OsVersion: "W11",
      AppVersion: AppVersion,
      DeviceId: "c81da199-9875-4bbf-9d12-411ffaa4c1ea",
      ClientId: "8d76d67e5605ccf0f97a2ac5ac8bc3da",
    }),
  });

  if (response.ok) {
    const data = await response.json();
    if (data.Data.ResponseCode === 435) {
      window.location.href = '/calendar';
      return null;
    }
    if (data && data.Data && data.Data.Records) {
      setTokens(
        data.Data.Records.AccessToken,
        data.Data.Records.RefreshToken,
        data.Data.Records.guid,
        data.Data.Records.id,
        data.Data.Records.Notifications,
        data.Data.Records.LicensePlateID,
        data.Data.Records.PrimaryEmail,
        data.Data.Records.FirstName,
        data.Data.Records.LastName,
         data.Data.Records.CreditBalance,
      );
      return data;
    } else {
      throw new Error("Login failed: Unexpected response format");
    }
  } else {
    throw new Error("Login failed");
  }
};


export const BASE_URL = process.env.REACT_APP_BASEAPI_URL;
export const LARAVEL_BASE_URL = process.env.REACT_APP_LARAVEL_API_URL ?? BASE_URL;
export const App_version = "13.2.2";
export const OsVersion = "13";
export const DeviceId = "TeamsAppDeviceId";
export const ManufactureModel = "TeamsAppModel";

export const ReactLogin_api = BASE_URL + "v5/ReactLogin_api";
export const User_login_api = BASE_URL + "v5/User_login_api";

export const VehicleRegistration_api = "v5/VehicleRegistration_api";
export const NotificationToggleStatus_api = "v5/NotificationToggleStatus_api";
export const NotificationToggleStatus_APIemailNotificationToggle = "v5/NotificationToggleStatus_api/emailNotificationToggle";
export const ToggleSyncBookingToggle_API = "v5/SyncBookingToggle_api";
export const EditProfile_api = "v5/EditProfile_api";
export const Token_api = "v5/Token_api";
export const Profile_api = "v5/Profile_api";
export const ZoneList_api = "v5/ZoneList_api";
export const HomeScreenBookings_api = "v5/HomeScreenBookings_api";
export const SearchBookings_api = "v5/SearchBookings_api";
export const EmployeeRole_api = "v5/EmployeeRole_api";
// RON-5587: MyBookings_api, MapCanvas_api and MapGrid_api are pinned to v6 (API_V6 below).
// RON-5410: the month lazy-loading calendar is served by v6/Calendar_api, which
// returns Data.LastBookingDate - the stop condition for the week-by-week queue.
// Pinned to v6 rather than the shared default so moving other endpoints between
// versions cannot silently change which calendar contract the month view talks to.
export const API_V6 = process.env.REACT_APP_API_V6 ?? "v6/";
export const Calendar_api = `${API_V6}Calendar_api`;
export const MyBookings_api = `${API_V6}MyBookings_api`;
export const MapCanvas_api = `${API_V6}MapCanvas_api`;
export const MapGrid_api = `${API_V6}MapGrid_api`;
export const MakeBooking_api = "v5.1/MakeBooking_api";
export const GetRandomPin_api = "v5/GetRandomPin_api";
export const CancelBooking_api = "v5/CancelBooking_api";
export const MeetingRoom_api = "v5/MeetingRoom_api/CreateNewMeeting";
export const MapBasedBooking_api = "v5.1/MapBasedBooking_api";
export const MeetingRoomListAndInfo = "v5/MeetingRoom_api/MeetingRoomListAndInfo";
export const GetParticipantsForMeeting = "v5/MeetingRoom_api/GetParticipantsForMeeting";
export const CheckInUser_api = "v5/CheckInUser_api";
export const BookingStatus_api = "v5/BookingStatus_api";
export const ChangePassword_API = "v5/ChangePassword_api";
export const GroupZoneList_API = "v5/GroupZoneList_api";
export const McpTokenGenerate_API = "v6/mcp-token/generate";
export const McpTokenList_API     = "v6/mcp-token/list";
export const McpTokenRevoke_API   = "v6/mcp-token";
export const VehicleRegistrationBulkAdd_API = "v5/VehicleRegistrationBulkAdd_api";
export const DeleteAccount_url = "v5/ConfirmDeleteAccount_api";




export const setTokens = (newAccessToken, newRefreshToken, newGuId, UserId, Notifications, LicensePlateID, PrimaryEmail, FirstName, LastName, CreditBalance) => {
  // localStorage.setItem("accessToken", newAccessToken);
  // localStorage.setItem("refreshToken", newRefreshToken);
  // localStorage.setItem("guId", newGuId); // Store GuId
  // localStorage.setItem("id", UserId)

  localStorage.setItem("accessToken", newAccessToken);
  localStorage.setItem("refreshToken", newRefreshToken);
  localStorage.setItem("guId", newGuId); // Store GuId
  localStorage.setItem("id", UserId);
  localStorage.setItem("Notifications", Notifications);
  localStorage.setItem("LicensePlateID", LicensePlateID);
  localStorage.setItem("PrimaryEmail", PrimaryEmail);
  localStorage.setItem("FirstName", FirstName);
  localStorage.setItem("LastName", LastName);
  localStorage.setItem("email", PrimaryEmail);
  localStorage.setItem("firstname", FirstName);
  localStorage.setItem("lastname", LastName);
  localStorage.setItem("Credit", CreditBalance)
};

//reactmemory version
// export const setTokens = (newAccessToken, newRefreshToken, newGuId, UserId, Notifications) => {
//   authMemory.setTokens({
//     accessToken: newAccessToken,
//     refreshToken: newRefreshToken,
//     guId: newGuId,
//     userId: UserId,
//     notifications: Notifications,
//   });
// };

// const getAccessToken = () => localStorage.getItem("accessToken");
// const getRefreshToken = () => localStorage.getItem("refreshToken");
// const getGuId = () => localStorage.getItem("guId"); // Retrieve GuId
// const msHomeAccountId = () => localStorage.getItem("msHomeAccountId")
// const getUserId = () => localStorage.getItem("id");

const getAccessToken = () => localStorage.getItem("accessToken");
const getRefreshToken = () =>
  localStorage.getItem("refreshToken") || localStorage.getItem("refreshToken");
const getGuId = () =>
  localStorage.getItem("guid") || localStorage.getItem("guId"); // Retrieve GuId
const msHomeAccountId = () => sessionStorage.getItem("msHomeAccountId")
const getUserId = () =>
  localStorage.getItem("id") || localStorage.getItem("loginid");
const getPrimaryEmail = () => localStorage.getItem("email") || localStorage.getItem("PrimaryEmail");;
const getFirstName = () => localStorage.getItem("firstname") || localStorage.getItem("FirstName");;
const getLastName = () => localStorage.getItem("lastname") || localStorage.getItem("LastName");;
// const getAccessToken = () => authMemory.getAccessToken();
// const getRefreshToken = () => authMemory.getRefreshToken();
// const getGuId = () => authMemory.getGuId();
// const getUserId = () => authMemory.getUserId();

const AppVersion = "13.2.2"

// var userFirstName = "Munaf S";
// var userEmailAddress = "munaf.mansuri@Ronspotflexwork.com";
// var userLastName = "";
// var userLicensePlateID = "";


const currentDate = new Date()
const day = currentDate.getDate();
const month = currentDate.getMonth() + 1;
const year = currentDate.getFullYear();
const TodayDate = year + "-" + month + "-" + day;

const isValidStoredValue = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  value !== "null" &&
  value !== "undefined";

const areTokensSet = () => {
  return isValidStoredValue(getRefreshToken()) &&
    isValidStoredValue(getGuId()) &&
    getUserId() !== null;
};

const EMERGENCY_ROLES_SYNC_ENDPOINTS = [
  HomeScreenBookings_api,
  SearchBookings_api,
  Calendar_api,
  MapGrid_api,
  Profile_api,
];

const shouldSyncEmergencyRoles = (url = "") =>
  EMERGENCY_ROLES_SYNC_ENDPOINTS.some((endpoint) => url.includes(endpoint));

// Fetch with token refresh
export const fetchWithTokenRefresh2 = async (url, options) => {
  if (!areTokensSet()) {
    throw new Error("Tokens are not set. Please login first.");
  }

  let currentAccessToken = getAccessToken();

  if (!isValidStoredValue(currentAccessToken)) {
    const refreshedTokens = await refreshAuthToken();
    currentAccessToken = refreshedTokens.accessToken;
  }

  let response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${currentAccessToken}`,
    },
  });

  if (response.status === 401) {
    const { accessToken } = await refreshAuthToken();

    response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    });
    // if (refreshResponse.ok) {
    //   const refreshData = await refreshResponse.json();
    //   setTokens(refreshData.Data.AccessToken, refreshData.Data.RefreshToken); // Save new tokens

    //   // Retry the original request with the new access token
    //   response = await fetch(url, {
    //     ...options,
    //     headers: {
    //       ...options.headers,
    //       Authorization: `Bearer ${getAccessToken()}`,
    //     },
    //   });
    // } else {
    //   clearTokens(); // Clear tokens if refresh fails
    //   throw new Error("Failed to refresh token. Please login again.");
    // }
  }

  if (response.ok && shouldSyncEmergencyRoles(url) && typeof response.clone === "function") {
    try {
      const payload = await response.clone().json();
      syncHasEmergencyRolesFromPayload(payload, { defaultToVisibleOnMissing: true });
    } catch (error) {
      console.warn("Unable to sync HasEmergencyRoles from response:", error);
    }
  }

  return response;
};

// export const Login = async (setError) => { // Added setError as a prop
//   try {
//     const response = await fetch(ReactLogin_api, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         MsHomeAccountId: msHomeAccountId(),
//         ManufactureModel: "react",
//         OsVersion: "W11",
//         AppVersion: AppVersion,
//         DeviceId: "c81da199-9875-4bbf-9d12-411ffaa4c1ea",
//         ClientId: "8d76d67e5605ccf0f97a2ac5ac8bc3da",
//       }),
//     });

//     if (response.ok) {
//       const data = await response.json();

//       if (data && data.Data && data.Data.ResponseCode === 435 && data.Data.ErrorMessage === "User is invalid") {
//         setError("Register first"); // Set the error message
//         return null; // Or handle as needed
//       }

//     } else {
//       throw new Error("Login failed: HTTP error");
//     }
//   } catch (error) {
//     console.error("Login error:", error);
//     setError(error.message || "An unexpected error occurred during login."); // Handle general errors
//     return null;
//   }
// };
// Login function

// export const LoginTeams = async () => {

//   const response = await fetch(ReactLogin_api, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({
//       MsHomeAccountId: msHomeAccountId(),
//       ManufactureModel: "react",
//       OsVersion: "W11",
//       AppVersion: AppVersion,
//       DeviceId: "c81da199-9875-4bbf-9d12-411ffaa4c1ea",
//       ClientId: "8d76d67e5605ccf0f97a2ac5ac8bc3da",
//     }),
//   });

//   if (response.ok) {
//     const data = await response.json();
//     console.log("Primary Email User:", data.Data.Records.PrimaryEmail);
//     userFirstName = data.Data.Records.FirstName;
//     userEmailAddress = data.Data.Records.PrimaryEmail;
//     userLastName = data.Data.Records.LastName;
//     userLicensePlateID = data.Data.Records.LicensePlateID;
    
//     if (data.Data.ResponseCode == 435) {
//       console.log(data.Data.ResponseCode)
//       console.log("Register first"); // Set the error message
//       window.location.href = '/calendar'; 
//       return null; // Or handle as needed
//     }

//     if (data && data.Data && data.Data.Records) {
//       setTokens(data.Data.Records.AccessToken, data.Data.Records.RefreshToken, data.Data.Records.guid, data.Data.Records.id); // Save tokens
//       return data;
//     } else{
//       throw new Error("Login failed: Unexpected response format");
//     }
//   }  else {
//     throw new Error("Login failed");
//   }
// };

// Max time to wait for the Teams login request before giving up. Prevents a
// hung/slow production API from stalling the Teams tab init indefinitely.
const LOGIN_TIMEOUT_MS = 20000;

export const Login = async () => {

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), LOGIN_TIMEOUT_MS);

  let response;
  try {
    response = await fetch(ReactLogin_api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        MsHomeAccountId: msHomeAccountId(),
        ManufactureModel: "react",
        OsVersion: "W11",
        AppVersion: AppVersion,
        DeviceId: "c81da199-9875-4bbf-9d12-411ffaa4c1ea",
        ClientId: "8d76d67e5605ccf0f97a2ac5ac8bc3da",
      }),
      signal: controller.signal,
    });
  } catch (error) {
    if (error?.name === "AbortError") {
      throw new Error("Login request timed out");
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }

  if (response.ok) {
    const data = await response.json();
    console.log("Primary Email User:", data.Data.Records.PrimaryEmail);
    // userFirstName = data.Data.Records.FirstName;
    // userEmailAddress = data.Data.Records.PrimaryEmail;
    // userLastName = data.Data.Records.LastName;
    // userLicensePlateID = data.Data.Records.LicensePlateID;

    if (data.Data.ResponseCode == 435) {
      console.log(data.Data.ResponseCode)
      console.log("Register first"); // Set the error message
      window.location.href = '/calendar';
      return null; // Or handle as needed
    }

    if (data && data.Data && data.Data.Records) {
      setTokens(
        data.Data.Records.AccessToken,
        data.Data.Records.RefreshToken,
        data.Data.Records.guid,
        data.Data.Records.id,
        data.Data.Records.Notifications,
        data.Data.Records.LicensePlateID,
        data.Data.Records.PrimaryEmail,
        data.Data.Records.FirstName,
        data.Data.Records.LastName,
         data.Data.Records.CreditBalance,
      );
      return data;
    } else {
      throw new Error("Login failed: Unexpected response format");
    }
  } else {
    throw new Error("Login failed");
  }
};

export const FetchCalendarWithZoneCalendartest = async () => {
  // Step 1: Call ZoneList API
  const zoneResponse = await fetchWithTokenRefresh2(BASE_URL + ZoneList_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      GuId: getGuId(),
      AppVersion: AppVersion,
      TeamMemberGuId: "",
      Language: AppConstant.Language,
      DeviceId: "e9155efc-82e7-4125-8cc0-015267306249",
      OsVersion: "10",
      ManufactureModel: "SM-M107F",
      TeamId: "",
      LogScreenName: "",
      LogActionType: "",
      LogPopup: ""
    }),
  });

  if (!zoneResponse.ok) {
    if (zoneResponse.status == 446) {
      console.log("Access token is not valid");
      return;
    } else if (zoneResponse.status == 453) {
      console.log("TeamMember position = 0, Team Member Data reset");
      return;
    } else if (zoneResponse.status == 423 || zoneResponse.status == 407) {
      console.log("User is not active. Logout user");
      return;
    } else if (zoneResponse.status == 401) {
      console.log("User is not registered");
      return;
    } else {
      throw new Error("Failed to fetch zone list");
    }
  }

  const zoneData = await zoneResponse.json();
  const defaultZone = zoneData?.Data?.Records?.ZoneList?.find(zone => zone.DefaultId === 1);
  const zoneId = defaultZone?.Id;

  if (!zoneId) {
    console.log("Default ZoneId not found");
    return;
  }

  // Step 2: Call Calendar API
  const calendarResponse = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ZoneId: zoneId,
      GuId: getGuId(),
      BookingStartDate: TodayDate,
      Month: month,
      Year: year,
      TeamMemberGuId: "",
      FilterStartTime: "",
      DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f",
      OsVersion: "10",
      TagsFilter: "",
      ManufactureModel: "Android SDK built for x86",
      IsGuest: 0,
      FuelFilter: "",
      AppVersion: AppVersion,
      ShareableFilter: "",
      Language: AppConstant.Language,
      FilterEndTime: "",
      VehicleTypeFilter: "",
      IsFromAppHome: 0,
      AccessibleFilter: "",
      FacilityFilter: "",
      LogScreenName: "",
      LogActionType: "",
      LogPopup: ""
    }),
  });

  if (!calendarResponse.ok) {
    throw new Error("Failed to fetch calendar data");
  }

  const calendarData = await calendarResponse.json();
  console.log("Calendar Data:", calendarData);
  return calendarData;
};

export const FetchCalendarWithZone = async (
  zoneIdToFetch = null,
  filters = {},
  teamMemberGuid = "",
  isGuestFlag = 0,
) => {
  // This function can now optionally take a zoneId, teamMemberGuid, and filters to fetch calendar data directly.
  console.log(filters, "===zoneIdToFetch, teamMemberGuid, filters===");

  let zoneData = null;
  let finalZoneId = zoneIdToFetch;

  const fetchZoneData = async () => {
    const zoneResponse = await fetchWithTokenRefresh2(BASE_URL + ZoneList_api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        GuId: getGuId(),
        AppVersion: AppVersion,
        TeamMemberGuId: teamMemberGuid || "",
        Language: AppConstant.Language,
        DeviceId: "e9155efc-82e7-4125-8cc0-015267306249",
        OsVersion: "10",
        ManufactureModel: "SM-M107F",
        TeamId: "",
        LogScreenName: "",
        LogActionType: "",
        LogPopup: ""
      }),
    });

    if (!zoneResponse.ok) {
      console.error("Failed to fetch zone list:", zoneResponse.status);
      return { zoneData: null, calendarData: null, error: "Zone list fetch failed" };
    }

    zoneData = await zoneResponse.json();
    const defaultZone =
      zoneData?.Data?.Records?.ZoneList?.find((zone) => zone.DefaultId === 1) ||
      zoneData?.Data?.Records?.ZoneList?.[0];
    finalZoneId = defaultZone?.Id;

    if (!finalZoneId) {
      console.log("Default ZoneId not found");
      return { zoneData, calendarData: null, error: "Default ZoneId not found" };
    }

    return { zoneData, error: null };
  };

  if (zoneIdToFetch === null) {
    const zoneFetchResult = await fetchZoneData();
    if (zoneFetchResult?.error) {
      return zoneFetchResult;
    }
  }

  if (!finalZoneId) {
    console.error("No ZoneId available to fetch calendar data.");
    return { zoneData, calendarData: null, error: "No ZoneId available" };
  }

  const fetchCalendarData = async (zoneId) => {
    const resolvedIsGuestFlag =
      typeof filters?.IsGuest !== "undefined" ? filters.IsGuest : isGuestFlag;

    const calendarResponse = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ZoneId: zoneId,
        GuId: getGuId(),
        BookingStartDate: TodayDate,
        Month: month,
        Year: year,
        TeamMemberGuId: teamMemberGuid || "",
        FilterStartTime: filters?.FilterStartTime || "",
        DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f",
        OsVersion: "10",
        TagsFilter: filters?.TagsFilter || "",
        ManufactureModel: "Android SDK built for x86",
        IsGuest: resolvedIsGuestFlag,
        FuelFilter: filters?.FuelFilter || "",
        AppVersion: AppVersion,
        ShareableFilter: filters?.ShareableFilter || "",
        Language: AppConstant.Language,
        FilterEndTime: filters?.FilterEndTime || "",
        VehicleTypeFilter: filters?.VehicleTypeFilter || "",
        IsFromAppHome: 0,
        AccessibleFilter: filters?.AccessibleFilter || "",
        FacilityFilter: filters?.FacilityFilter || "",
        LogScreenName: "",
        LogActionType: "",
        LogPopup: ""
      }),
    }, console.log("THIS IS CALLING AFTER CALENDAR"));

    if (!calendarResponse.ok) {
      console.error("Failed to fetch calendar data:", calendarResponse.status);
      throw new Error("Failed to fetch calendar data");
    }

    return await calendarResponse.json();
  };

  let calendarData = await fetchCalendarData(finalZoneId);
  console.log("Calendar Data:", calendarData);

  if (calendarData?.Data?.ResponseCode === 448 && teamMemberGuid) {
    const zoneFetchResult = await fetchZoneData();
    if (zoneFetchResult?.error) {
      return { zoneData, calendarData, error: zoneFetchResult.error };
    }

    calendarData = await fetchCalendarData(finalZoneId);
    console.log("Calendar Data After 448 Zone Refresh:", calendarData);
  }

  return { zoneData, calendarData, error: null };
};

// RON-5410: the month lazy-load queue asks for one week at a time and identifies a
// week by its Monday. Callers hand us whatever day they are rendering, so normalise
// to that week's Monday here rather than at each call site.
function getMondayBookingStartDate(dateValue) {
  const parsedDate = new Date(dateValue);
  if (Number.isNaN(parsedDate.getTime())) {
    return "";
  }

  parsedDate.setHours(0, 0, 0, 0);
  const dayOfWeek = parsedDate.getDay();
  const diff = parsedDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
  const monday = new Date(parsedDate);
  monday.setDate(diff);
  monday.setHours(0, 0, 0, 0);

  return `${monday.getFullYear()}-${String(monday.getMonth() + 1).padStart(2, "0")}-${String(monday.getDate()).padStart(2, "0")}`;
}

export const BookingCancelNewWeekRefresh = async (bookingDateStr, zoneId, passMonthtoAPI,selectedTeamMember,activeGuestFlag,filters) => {
  console.log("BookingCancelNewWeekRefresh()", bookingDateStr, zoneId,filters);
  let zoneData = null;
  let finalZoneId = zoneId;
  const nextyear = new Date(bookingDateStr).getFullYear() ;
  const mondayBookingStartDate = getMondayBookingStartDate(bookingDateStr);

  if (zoneId === null) { // Only call ZoneList API if we need to find the default zone
    const zoneResponse = await fetchWithTokenRefresh2(BASE_URL + ZoneList_api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        GuId: getGuId(),
        AppVersion: AppVersion,
        TeamMemberGuId: "",
        Language: AppConstant.Language,
        DeviceId: "e9155efc-82e7-4125-8cc0-015267306249",
        OsVersion: "10",
        ManufactureModel: "SM-M107F",
        TeamId: "",
        LogScreenName: "",
        LogActionType: "",
        LogPopup: ""
      }),
    });

    if (!zoneResponse.ok) {
      // Handle error codes as before. You might want to throw specific errors
      // or return a structured error object.
      console.error("Failed to fetch zone list:", zoneResponse.status);
      return { zoneData: null, calendarData: null, error: "Zone list fetch failed" };
    }

    zoneData = await zoneResponse.json();
    const defaultZone = zoneData?.Data?.Records?.ZoneList?.find(zone => zone.DefaultId === 1);
    finalZoneId = defaultZone?.Id;

    if (!finalZoneId) {
      console.log("Default ZoneId not found");
      return { zoneData, calendarData: null, error: "Default ZoneId not found" };
    }
  }

  if (!finalZoneId) {
    console.error("No ZoneId available to fetch calendar data.");
    return { zoneData, calendarData: null, error: "No ZoneId available" };
  }

  // Step 2: Call Calendar API with the determined zoneId
  const calendarResponse = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ZoneId: finalZoneId, // Use the determined or passed zoneId
      GuId: getGuId(),
      BookingStartDate: mondayBookingStartDate,
      Month: passMonthtoAPI,
      //Year: year,
      Year: nextyear,
      TeamMemberGuId: selectedTeamMember,
      FilterStartTime: filters?.FilterStartTime || "",
      DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f",
      OsVersion: "10",
      TagsFilter: filters?.TagsFilter || "",
      ManufactureModel: "Android SDK built for x86",
      IsGuest: activeGuestFlag,
      FuelFilter: filters?.FuelFilter || "",
      AppVersion: AppVersion,
      ShareableFilter: filters?.ShareableFilter || "",
      Language: AppConstant.Language,
      FilterEndTime: filters?.FilterEndTime || "",
      VehicleTypeFilter: filters?.VehicleTypeFilter || "",
      IsFromAppHome: 0,
      AccessibleFilter: filters?.AccessibleFilter || "",
      FacilityFilter: filters?.FacilityFilter || "",
      LogScreenName: "",
      LogActionType: "",
      LogPopup: ""
    }),

  }, console.log("THIS IS CALLING AFTER CALENDAR"));

  if (!calendarResponse.ok) {
    console.error("Failed to fetch calendar data:", calendarResponse.status);
    throw new Error("Failed to fetch calendar data"); // Re-throw to be caught by caller
  }

  const calendarData = await calendarResponse.json();
  console.log("Calendar Data:", calendarData);

  return { zoneData, calendarData, error: null };
  // Implement the API call logic here
};

// Fetch ZoneList function
export const ZoneList = async (teamMemberGuId) => {

  const response = await fetchWithTokenRefresh2(BASE_URL + ZoneList_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      GuId: getGuId(),
      AppVersion: AppVersion,
      TeamMemberGuId: teamMemberGuId||"",
      Language: AppConstant.Language,
      DeviceId: "e9155efc-82e7-4125-8cc0-015267306249",
      OsVersion: "10",
      ManufactureModel: "SM-7292",
      TeamId: "",
      LogScreenName: "",
      LogActionType: "",
      LogPopup: ""
    }),
  });
  if (response.ok) {
    return await response.json();
  } 
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if(response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if(response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

// Fetch profile function
export const fetchProfile = async () => {

  const response = await fetchWithTokenRefresh2(BASE_URL + Profile_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      GuId: getGuId(),
      Language: AppConstant.Language,
      DeviceId: "c90d1fa3-e837-46e7-a5e2-15a9ad5ce21d",
      OsVersion: "10",
      ManufactureModel: "AndroidSDK built for x86",
      AppVersion: AppVersion,
    }),
  });
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error("Failed to fetch profile");
  }
};

//MyBooking function
export const MyBooking = async () => {
  // if (!areTokensSet()) {
  //   console.log("Tokens not found. Logging in...");
  //   await Login(); // Wait for login to complete
  // }

  const response = await fetchWithTokenRefresh2(BASE_URL + HomeScreenBookings_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      AppVersion: AppVersion,
      Language: AppConstant.Language,
      DeviceId: "e9155efc-82e7-4125-8cc0-015267306249",
      OsVersion: "11",
      GuId: getGuId(),
      ManufactureModel: "SM-M107F",
      LogScreenName: "",
      LogActionType: "",
      LogPopup: ""
    }),
  });
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error("Failed to fetch profile");
  }
};

export const findColleagues = async (selectedZoneId, selectedColleagueId) => {
  // if (!areTokensSet()) {
  //   console.log("Tokens not found. Logging in...");
  //   await Login(); // Wait for login to complete
  // }

  const response = await fetchWithTokenRefresh2(BASE_URL + SearchBookings_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      AppVersion: AppVersion,
      SearchMemberId: selectedColleagueId || 0,
      Language: AppConstant.Language,
      ZoneId: selectedZoneId || "0",
      DeviceId: "",
      OsVersion: 10,
      ManufactureModel: "Android SDK built for x86",
      GuId: getGuId(),
    }),
  });
  if (response.ok) {
    console.log("Colleagues fetched");
    return await response.json();
  } else {
    throw new Error("Failed to fetch profile");
  }
}

export const employeeRole_api = async (zoneIds, roleId) => {
  // if (!areTokensSet()) {
  //   console.log("Tokens not found. Logging in...");
  //   await Login(); // Wait for login to complete
  // }

  const response = await fetchWithTokenRefresh2(BASE_URL + EmployeeRole_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
        AppVersion: AppVersion,
        Language: AppConstant.Language,
         ZoneId: zoneIds,
            EmployeeRoleId: roleId,
        DeviceId: "c81da199-9875-4bbf-9d12-411ffaa4c1ea",
        OsVersion: "10",
        GuId: getGuId(),
        ManufactureModel: "Android SDK built for x86"
    }),
  });
  if (response.ok) {
    console.log("Colleagues fetched");
    return await response.json();
  } else {
    throw new Error("Failed to fetch profile");
  }
}

export const MyBookings_api_function = async () => {

  const profileData = await fetchProfile();

  if (!profileData) {
    console.log("Profile data not found. Logging in...");
  }
  // if (!areTokensSet()) {
  //   console.log("Tokens not found. Logging in...");
  //   await Login();
  // }

  const response = await fetchWithTokenRefresh2(BASE_URL + MyBookings_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ZoneId: profileData.Data.Records.ZoneId,
      BookingDate: "", //if empty = Today Date
      Language: AppConstant.Language,
      ManufactureModel: "SM-M107F",
      AppVersion: AppVersion,
      DeviceId: "c90d1fa3-e837-46e7-a5e2-15a9ad5ce21d",
      GuId: getGuId(),
      OsVersion: "11",
      LogScreenName: "",
      LogActionType: "",
      LogPopup: ""
    }),
  });
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error("Failed to fetch profile");
  }
};

export const Calendar_API = async () => {

  // const profileData = await fetchProfile();
  const profileData = await ZoneList();
  const defaultZone = profileData.Data.Records.ZoneList.find(zone => zone.DefaultId === 1);
  console.log('defaultZone', defaultZone);

  if(!profileData){
    console.log("Profile data not found. Logging in...");
  }

  const response = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
        // ZoneId: 2562,
        ZoneId: defaultZone.Id,
        GuId: getGuId(),
        BookingStartDate: TodayDate,
        Month: month,
        Year: year,
    
        TeamMemberGuId: "",
        FilterStartTime: "",
        DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f",
        OsVersion: "10",
        TagsFilter: "",
        ManufactureModel: "Android SDK built for x86",
        IsGuest: 0,
        FuelFilter: "",
        AppVersion: AppVersion,
        ShareableFilter: "",
        Language: AppConstant.Language,
        FilterEndTime: "",
        VehicleTypeFilter: "",
        IsFromAppHome: 0,
        AccessibleFilter: "",
        FacilityFilter: "",
        LogScreenName: "",
        LogActionType: "",
        LogPopup: ""
    }),
  });
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error("Failed to fetch profile");
  }
};

export const Calendar_APIforBooking = async (bookingDateStr, zoneId) => {
  const bookingDateToUse = bookingDateStr || TodayDate;

  // Extract month and year from the booking date
  const date = new Date(bookingDateToUse);
  const month = date.getMonth() + 1; // getMonth() is 0-indexed
  const year = date.getFullYear();

  const response = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ZoneId: zoneId,
      GuId: getGuId(),
      BookingStartDate: bookingDateToUse,
      Month: month,
      Year: year,
      TeamMemberGuId: "",
      FilterStartTime: "",
      DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f",
      OsVersion: "10",
      TagsFilter: "",
      ManufactureModel: "Android SDK built for x86",
      IsGuest: 0,
      FuelFilter: "",
      AppVersion: AppVersion,
      ShareableFilter: "",
      Language: AppConstant.Language,
      FilterEndTime: "",
      VehicleTypeFilter: "",
      IsFromAppHome: 0,
      AccessibleFilter: "",
      FacilityFilter: "",
      LogScreenName: "",
      LogActionType: "",
      LogPopup: ""
    }),
  });

  if (response.ok) {
    return await response.json();
  } else {
    throw new Error("Failed to fetch calendar data");
  }
};

export const MapCanvas_API = async (zoneId, bookingDateStr,teamMemberGuId,safeTeamId,safeIsGuest, filters = {}) => {

  const samevalue = getGuId() == teamMemberGuId
  const teamMemberID = samevalue ? "" : teamMemberGuId

  const normalizeFilterValue = (value) => {
    if (Array.isArray(value)) return value.join(",");
    return value || "";
  };

  const response = await fetchWithTokenRefresh2(BASE_URL + MapCanvas_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      BookingDate: bookingDateStr,
      ZoneId: zoneId,
      DeviceId: DeviceId,
      OsVersion: OsVersion,
      GuId: getGuId(),
      ManufactureModel: ManufactureModel,
      AppVersion: App_version,
      TeamMemberGuId: teamMemberID,
      Language: AppConstant.Language,
      IsGuest: safeIsGuest,
      TeamId: safeTeamId,

     FilterStartTime: normalizeFilterValue(filters?.FilterStartTime),
      FilterEndTime: normalizeFilterValue(filters?.FilterEndTime),
      FuelFilter: normalizeFilterValue(filters?.FuelFilter),
      AccessibleFilter: normalizeFilterValue(filters?.AccessibleFilter),
      ShareableFilter: normalizeFilterValue(filters?.ShareableFilter),
      FacilityFilter: normalizeFilterValue(filters?.FacilityFilter),
      TagsFilter: normalizeFilterValue(filters?.TagsFilter),
      VehicleTypeFilter: normalizeFilterValue(filters?.VehicleTypeFilter),
      // LogScreenName: "",
      // LogActionType: "",
      // LogPopup: ""

    }),
  });
  if (response.ok) {
    return await response.json();
  } 
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if(response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if(response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

export const MapGrid_API = async (zoneId, bookingDateStr,teamMemberGuId,safeTeamId,safeIsGuest, filters = {}) => {

  const samevalue = getGuId() == teamMemberGuId
  const teamMemberID = samevalue ? "" : teamMemberGuId

  const normalizeFilterValue = (value) => {
    if (Array.isArray(value)) return value.join(",");
    return value || "";
  };

  const response = await fetchWithTokenRefresh2(BASE_URL + MapGrid_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      GuId: getGuId(),
      BookingDate: bookingDateStr,
      AppVersion: App_version,
      ZoneId: zoneId,     
      IsGuest: safeIsGuest,
      TeamId: safeTeamId,
      DeviceId: DeviceId,
      OsVersion: OsVersion,
      ManufactureModel: ManufactureModel,
      TeamMemberGuId: teamMemberID,
      Language: AppConstant.Language,

      FilterStartTime: normalizeFilterValue(filters?.FilterStartTime),
      FilterEndTime: normalizeFilterValue(filters?.FilterEndTime),
      FuelFilter: normalizeFilterValue(filters?.FuelFilter),
      AccessibleFilter: normalizeFilterValue(filters?.AccessibleFilter),
      ShareableFilter: normalizeFilterValue(filters?.ShareableFilter),
      FacilityFilter: normalizeFilterValue(filters?.FacilityFilter),
      TagsFilter: normalizeFilterValue(filters?.TagsFilter),
      VehicleTypeFilter: normalizeFilterValue(filters?.VehicleTypeFilter),
    }),
  });
  if (response.ok) {
    return await response.json();
  } 
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if(response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if(response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

export const FetchZoneWithMapCanvas_API = async () => {
    try {
        console.log("Fetching profile data...");
        const profileData = await ZoneList(); // Assuming ZoneList correctly fetches profile data with zones

        if (!profileData || profileData.Data?.ResponseCode !== 200 || !profileData.Data?.Records?.ZoneList) {
            console.error("Failed to fetch valid profile data or zone list:", profileData);
            throw new Error("Profile data or ZoneList not found.");
        }

        const defaultZone = profileData.Data.Records.ZoneList.find(zone => zone.DefaultId === 1);
        console.log('Default Zone found:', defaultZone);

        if (!defaultZone) {
            console.error("No default zone found in the list.");
            throw new Error("No default zone found.");
        }

        const currentBookingDate = new Date().toISOString().split('T')[0]; // Ensure correct YYYY-MM-DD format
        const currentGuId = getGuId(); // Ensure this returns a valid string

        if (!currentGuId) {
            console.error("GUID is not available.");
            throw new Error("GUID not available.");
        }

        const requestBody = {
            BookingDate: currentBookingDate,
            ZoneId: defaultZone.Id,
            FilterEndTime: "",
            DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f", // Consider making this dynamic if needed
            OsVersion: "10",
            FilterStartTime: "",
            GuId: currentGuId,
            ManufactureModel: "Android SDK built for x86",
            AppVersion: AppVersion,
            TeamMemberGuId: "0",
            Language: AppConstant.Language,
            FacilityFilter: "",
            TagsFilter: "",
            VehicleTypeFilter: "",
            FuelFilter: "",
            AccessibleFilter: "",
            ShareableFilter: "",
            TeamId: "",
            IsGuest: 0,
            LogScreenName: "",
            LogActionType: "",
            LogPopup: ""
        };

        console.log("Requesting Map Canvas with payload:", requestBody);
        console.log("Target URL:", BASE_URL + MapCanvas_api);

        // Step 2: Call MapCanvas_api API
        const calendarResponse = await fetchWithTokenRefresh2(BASE_URL + MapCanvas_api, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        // Log the raw response status and headers
        console.log("Raw API response status:", calendarResponse.status);
        console.log("Raw API response headers:", calendarResponse.headers);

        if (!calendarResponse.ok) {
            // If the response is not OK (e.g., 303, 401, 404, 500)
            const errorText = await calendarResponse.text(); // Get raw response text for debugging
            console.error(`API response was not OK: ${calendarResponse.status} - ${calendarResponse.statusText}. Response Body:`, errorText);
            throw new Error(`Failed to fetch calendar data: ${calendarResponse.status} ${calendarResponse.statusText}`);
        }

        const calendarData = await calendarResponse.json();
        console.log("Calendar Data (parsed JSON):", calendarData);
        return calendarData;

    } catch (error) {
        console.error('Error in FetchZoneWithMapCanvas_API:', error);
        // Re-throw the error so the calling component can handle it (e.g., show an error message)
        throw error;
    }
};

export const MakeBooking_API = async (
  zoneId,
  bookingDateStr,
  VehicleTypeId,
  fuelId,
  vehicleShareableId,
  vehicleAccessibleId,
  vehicleRegistrationId,
  selectedTeamMember,
  isGuestFlag,
  guestData = null,
  tagsFilter = ""
) => {
  const response = await fetchWithTokenRefresh2(BASE_URL + MakeBooking_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      BookingDate: bookingDateStr,
      ZoneId: zoneId,
      GuId: getGuId(),
      ManufactureModel: "Android SDK built for x86",
      TeamLeaderGuId: getGuId(),
      Language: AppConstant.Language,
      FirstName: guestData?.guestName || getFirstName(),
      EmailAddress: guestData?.guestEmail || getPrimaryEmail(),
      LastName: guestData?.guestLastName || getLastName(),
      AppVersion: AppVersion,
      DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f",
      OsVersion: "10",
      NationalId: guestData?.guestIdentification || "",
      IsGuest: isGuestFlag,
      Tags: tagsFilter || "",
      TeamMemberGuId: selectedTeamMember,

      VehicleFuelId: fuelId,
      VehicleTypeId: VehicleTypeId,
      VehicleShareableId: vehicleShareableId,
      CarRegistrationNumber: guestData?.guestVehicleNumber || "",
      VehicleAccessibleId: vehicleAccessibleId,

      // Guest barrier access (ACT365). Defaults keep non-guest bookings unaffected.
      NumberPlateBarrierAccess: guestData?.numberPlateBarrierAccess ? 1 : 0,
      KeypadBarrierAccess: guestData?.keypadBarrierAccess ? 1 : 0,
      KeypadBarrierAccessPinCode: guestData?.keypadBarrierAccessPinCode || "",
      FireStoreId: ""
    }),
  });
  if (response.ok) {
    return await response.json();
  }
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if (response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if (response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

// Fetch a random guest PIN for keypad barrier access (ACT365).
// Pass the connected zone id; returns the API envelope { Data: { Records: { Pin } } }.
export const GetRandomPin_API = async (zoneId) => {
  const response = await fetchWithTokenRefresh2(BASE_URL + GetRandomPin_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      GuId: getGuId(),
      ZoneId: zoneId,
      AppVersion: AppVersion,
      DeviceId: DeviceId,
      OsVersion: OsVersion,
      ManufactureModel: ManufactureModel,
      Language: AppConstant.Language,
    }),
  });
  if (response.ok) {
    return await response.json();
  }
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if (response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if (response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch random pin");
  }
};

export const BookingStatus_API = async  (
    zoneId,
  bookingDateStr,
  VehicleTypeId,
  fuelId,
  vehicleShareableId,
  vehicleAccessibleId,
  vehicleRegistrationId
) => {
  const response = await fetchWithTokenRefresh2 (BASE_URL + BookingStatus_api , {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      BookingDate: bookingDateStr,
      ZoneId: zoneId,
      GuId: getGuId(),
      ManufactureModel: "Android SDK built for x86",
      TeamLeaderGuId: getGuId(),
      Language: AppConstant.Language,
      FirstName: getFirstName(),
      EmailAddress: getPrimaryEmail(),
      LastName: getLastName(),
      AppVersion: AppVersion,
      DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f",
      OsVersion: "10",
      NationalId: "",
      IsGuest: 0,
      Tags: "",
      TeamMemberGuId: "",

      VehicleFuelId: fuelId,
      VehicleTypeId: VehicleTypeId,
      VehicleShareableId: vehicleShareableId,
      CarRegistrationNumber: vehicleRegistrationId,
      VehicleAccessibleId: vehicleAccessibleId
  })
  })
  if (response.ok) {
    return await response.json();
  }
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if (response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if (response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

export const CancelBooking_API_Map = async (zoneId, bookingDateStr, cancelBookingSpotId, teamMemberGuId, IsGuest) => {
  const response = await fetchWithTokenRefresh2(BASE_URL + CancelBooking_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ZoneId: zoneId,
      BookingDate: bookingDateStr,
      SpotId: cancelBookingSpotId,
      GuId: getGuId(),
      TeamLeaderGuId: getGuId(),
      AppVersion: AppVersion,
      TeamMemberGuId: teamMemberGuId,
      Language: AppConstant.Language,
      IsGuest: IsGuest,
      DeviceId: "teams-device",
      OsVersion: "11",
      ManufactureModel: "SM-M107F"

    }),
  });
  if (response.ok) {
    return await response.json();
  } 
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if(response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if(response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

export const CancelBooking_API_LeaveQueue = async (zoneId, bookingDateStr, cancelBookingSpotId, teamMemberGuId, IsGuest) => {
  const response = await fetchWithTokenRefresh2(BASE_URL + CancelBooking_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ZoneId: zoneId,
      BookingDate: bookingDateStr,
      SpotId: -1,
      GuId: getGuId(),
      TeamLeaderGuId: getGuId(),
      AppVersion: AppVersion,
      TeamMemberGuId: teamMemberGuId,
      Language: AppConstant.Language,
      IsGuest: IsGuest,
      DeviceId: DeviceId,
      OsVersion: OsVersion,
      ManufactureModel: ManufactureModel
    }),
  });
  if (response.ok) {
    return await response.json();
  } 
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if(response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if(response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

export const CancelBooking_API = async (zoneId, bookingDateStr, cancelBookingSpotId, selectedTeamMember,activeGuestFlag) => {
  const response = await fetchWithTokenRefresh2(BASE_URL + CancelBooking_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ZoneId: zoneId,
      BookingDate: bookingDateStr,
      SpotId: cancelBookingSpotId,
      GuId: getGuId(),
      TeamLeaderGuId: getGuId(),
      AppVersion: AppVersion,
      TeamMemberGuId: selectedTeamMember,
      Language: AppConstant.Language,
      IsGuest: activeGuestFlag,
      DeviceId: "teams-device",
      OsVersion: "11",
      ManufactureModel: "SM-M107F"

    }),
  });
  if (response.ok) {
    return await response.json();
  } 
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if(response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if(response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

export const DeleteAccount_API = async () => {
  const response = await fetchWithTokenRefresh2(BASE_URL + DeleteAccount_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      GuId: getGuId(),
    }),
  });

  if (response.ok) {
    return await response.json();
  }
  else {
    throw new Error("Failed to delete account");
  }
};

export const CheckInOutsingleBtn = async (zoneId, bookingDateStr, cancelBookingSpotId,checkInFlag) => {
  const response = await fetchWithTokenRefresh2(BASE_URL + CheckInUser_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
     Longitude: "",
      Latitude: "",
      GuId: getGuId(),
      ClaimFromFlag: 0,
      ScanTime: 0,
      CheckInType: 2,
      App: "1",
      
      ZoneId: zoneId,
      CheckInFlag: checkInFlag,
      CheckInDate: bookingDateStr, //BookingDate: bookingDateStr,
      SpotId: cancelBookingSpotId,
      AppVersion: AppVersion,
      DeviceId: DeviceId,
      OsVersion: OsVersion,
      ManufactureModel: ManufactureModel,
      Language: AppConstant.Language

    }),
  });
  if (response.ok) {
    return await response.json();
  } 
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if(response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if(response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

export const CheckInUser_API = async (zoneId, bookingDateStr, cancelBookingSpotId) => {
  const response = await fetchWithTokenRefresh2(BASE_URL + CheckInUser_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
     Longitude: "",
      Latitude: "",
      GuId: getGuId(),
      ClaimFromFlag: 0,
      ScanTime: 0,
      CheckInType: 2,
      App: "1",
      
      ZoneId: zoneId,
      CheckInFlag: 1,
      CheckInDate: bookingDateStr, //BookingDate: bookingDateStr,
      SpotId: cancelBookingSpotId,
      AppVersion: AppVersion,
      DeviceId: DeviceId,
      OsVersion: OsVersion,
      ManufactureModel: ManufactureModel,
      Language: AppConstant.Language

    }),
  });
  if (response.ok) {
    return await response.json();
  } 
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if(response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if(response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

export const CheckOutUser_API = async (zoneId, bookingDateStr, cancelBookingSpotId) => {
  const response = await fetchWithTokenRefresh2(BASE_URL + CheckInUser_api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
     Longitude: "",
      Latitude: "",
      GuId: getGuId(),
      ClaimFromFlag: 0,
      ScanTime: 0,
      CheckInType: 2,
      App: "1",
      
      ZoneId: zoneId,
      CheckInFlag: 2,
      CheckInDate: bookingDateStr, //BookingDate: bookingDateStr,
      SpotId: cancelBookingSpotId,
      AppVersion: AppVersion,
      DeviceId: DeviceId,
      OsVersion: OsVersion,
      ManufactureModel: ManufactureModel,
      Language: AppConstant.Language

    }),
  });
  if (response.ok) {
    return await response.json();
  } 
  else if (response.status == 446) {
    console.log("Access token is not valid");
    return
  }
  else if (response.status == 453) {
    console.log("TeamMember position = 0 , Team Member Data reset");
    return
  } else if(response.status == 423 || response.status == 407) {
    console.log("UserIs not active Logout user");
  } else if(response.status == 401) {
    console.log("User is not registered");
  }
  else {
    throw new Error("Failed to fetch zone list");
  }
};

export const CreateNewMeeting = async (meetingTitle, meetingDateStr, startTimeStr, endTimeStr, roomId) => {
}


// Initialize app
// const initializeApp = async () => {
//   try {
//     const profileResponse = await fetchProfile();
//     console.log("Profile fetched:", profileResponse);
//   } catch (error) {
//     console.error("Error:", error.message);
//   }
// };

// initializeApp();


// Login in every API
// export const BASE_URL = "https://staging.ronspot.ie/api/v5/";
// export const ReactLogin_api = BASE_URL + "ReactLogin_api";
// export const VehicleRegistration_api = "VehicleRegistration_api";
// export const NotificationToggleStatus_api = "NotificationToggleStatus_api";
// export const EditProfile_api = "EditProfile_api";
// export const Token_api = "Token_api";
// export const Profile_api = "Profile_api";
// export const HomeScreenBookings_api = "HomeScreenBookings_api";
// export const SearchBookings_api = "SearchBookings_api";
// export const EmployeeRole_api = "EmployeeRole_api";
// export const MyBookings_api = "MyBookings_api";
// export const Calendar_api = "Calendar_api";

// const setTokens = (newAccessToken, newRefreshToken, newGuId) => {
//   localStorage.setItem("accessToken", newAccessToken);
//   localStorage.setItem("refreshToken", newRefreshToken);
//   localStorage.setItem("guId", newGuId); // Store GuId
// };

// const getAccessToken = () => localStorage.getItem("accessToken");
// const getRefreshToken = () => localStorage.getItem("refreshToken");
// const getGuId = () => localStorage.getItem("guId"); // Retrieve GuId
// const msHomeAccountId = () => localStorage.getItem("msHomeAccountId")

// const currentDate = new Date()
// const day = currentDate.getDate();
// const month = currentDate.getMonth() + 1;
// const year = currentDate.getFullYear();
// const TodayDate = year + "-" + month + "-" + day;

// const clearTokens = () => {
//   localStorage.removeItem("accessToken");
//   localStorage.removeItem("refreshToken");
// };

// const areTokensSet = () => {
//   return getAccessToken() !== null && getRefreshToken() !== null && getGuId() !== null && msHomeAccountId() !== null;
// };

// export const fetchWithTokenRefresh2 = async (url, options) => {
//   let response = await fetch(url, options);

//   if (response.status === 401) {
//     // Refresh the token
//     const refreshResponse = await fetch(BASE_URL + Token_api, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         AppVersion: "12.15.0",
//         RefreshToken: localStorage.getItem("refreshToken"),
//         Language: "english",
//         DeviceId: "c90d1fa3-e837-46e7-a5e2-15a9ad5ce21d",
//         OsVersion: "11",
//         ClientId: "8d76d67e5605ccf0f97a2ac5ac8bc3da",
//         GrantType: "User",
//         GuId: getGuId(),
//         ManufactureModel: "RMX2027",
//       }),
//     });

//     if (refreshResponse.ok) {
//       const refreshData = await refreshResponse.json();
//       const newAccessToken = refreshData.Data.Records.AccessToken;
//       const newRefreshToken = refreshData.Data.Records.RefreshToken;

//       // Update the tokens in localStorage
//       localStorage.setItem("accessToken", newAccessToken);
//       localStorage.setItem("refreshToken", newRefreshToken);

//       // Retry the original request with the new access token
//       options.headers.Authorization = `Bearer ${newAccessToken}`;
//       response = await fetch(url, options);
//     } else {
//       throw new Error("Failed to refresh token");
//     }
//   }

//   return response;
// };
// // Fetch with token refresh
// export const fetchWithTokenRefresh = async (url, options) => {
//   if (!areTokensSet()) {
//     throw new Error("Tokens are not set. Please login first.");
//   }

//   let response = await fetch(url, {
//     ...options,
//     headers: {
//       ...options.headers,
//       Authorization: `Bearer ${getAccessToken()}`,
//     },
//   });

//   if (response.status === 401) {
//     // Token is expired, refresh it
//     const refreshResponse = await fetch(BASE_URL + Token_api, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         AppVersion: "12.15.0",
//         RefreshToken: getRefreshToken(),
//         Language: "english",
//         DeviceId: "c90d1fa3-e837-46e7-a5e2-15a9ad5ce21d",
//         OsVersion: "11",
//         ClientId: "8d76d67e5605ccf0f97a2ac5ac8bc3da",
//         GrantType: "User",
//         GuId: getGuId(),
//         ManufactureModel: "RMX2027",
//       }),
//     });

//     if (refreshResponse.ok) {
//       const refreshData = await refreshResponse.json();
//       setTokens(refreshData.Data.AccessToken, refreshData.Data.RefreshToken); // Save new tokens

//       // Retry the original request with the new access token
//       response = await fetch(url, {
//         ...options,
//         headers: {
//           ...options.headers,
//           Authorization: `Bearer ${getAccessToken()}`,
//         },
//       });
//     } else {
//       clearTokens(); // Clear tokens if refresh fails
//       throw new Error("Failed to refresh token. Please login again.");
//     }
//   }

//   return response;
// };

// // export const Login = async (setError) => { // Added setError as a prop
// //   try {
// //     const response = await fetch(ReactLogin_api, {
// //       method: "POST",
// //       headers: { "Content-Type": "application/json" },
// //       body: JSON.stringify({
// //         MsHomeAccountId: msHomeAccountId(),
// //         ManufactureModel: "react",
// //         OsVersion: "W11",
// //         AppVersion: "1.0.1",
// //         DeviceId: "c81da199-9875-4bbf-9d12-411ffaa4c1ea",
// //         ClientId: "8d76d67e5605ccf0f97a2ac5ac8bc3da",
// //       }),
// //     });

// //     if (response.ok) {
// //       const data = await response.json();

// //       if (data && data.Data && data.Data.ResponseCode === 435 && data.Data.ErrorMessage === "User is invalid") {
// //         setError("Register first"); // Set the error message
// //         return null; // Or handle as needed
// //       }

// //     } else {
// //       throw new Error("Login failed: HTTP error");
// //     }
// //   } catch (error) {
// //     console.error("Login error:", error);
// //     setError(error.message || "An unexpected error occurred during login."); // Handle general errors
// //     return null;
// //   }
// // };
// // Login function
// export const Login = async () => {
//   const response = await fetch(ReactLogin_api, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({
//       MsHomeAccountId: msHomeAccountId(),
//       ManufactureModel: "react",
//       OsVersion: "W11",
//       AppVersion: "1.0.1",
//       DeviceId: "c81da199-9875-4bbf-9d12-411ffaa4c1ea",
//       ClientId: "8d76d67e5605ccf0f97a2ac5ac8bc3da",
//     }),
//   });

//   if (response.ok) {
//     const data = await response.json();
    
//     if (data.Data.ResponseCode == 435) {
//       console.log(data.Data.ResponseCode)
//       console.log("Register first"); // Set the error message
//       window.location.href = '/calendar'; 
//       return null; // Or handle as needed
//     }

//     if (data && data.Data && data.Data.Records) {
//       setTokens(data.Data.Records.AccessToken, data.Data.Records.RefreshToken, data.Data.Records.guid); // Save tokens
//       return data;
//     } else{
//       throw new Error("Login failed: Unexpected response format");
//     }
//   }  else {
//     throw new Error("Login failed");
//   }
// };

// // Fetch profile function
// export const fetchProfile = async () => {
//   if (!areTokensSet()) {
//     console.log("Tokens not found. Logging in...");
//     await Login();
//   }

//   const response = await fetchWithTokenRefresh(BASE_URL + Profile_api, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//       GuId: getGuId(),
//       Language: "english",
//       DeviceId: "c90d1fa3-e837-46e7-a5e2-15a9ad5ce21d",
//       OsVersion: "10",
//       ManufactureModel: "AndroidSDK built for x86",
//       AppVersion: "12.5.0",
//     }),
//   });
//   if (response.ok) {
//     return await response.json();
//   } else {
//     throw new Error("Failed to fetch profile");
//   }
// };

// //MyBooking function
// export const MyBooking = async () => {
//   if (!areTokensSet()) {
//     console.log("Tokens not found. Logging in...");
//     await Login(); // Wait for login to complete
//   }

//   const response = await fetchWithTokenRefresh(BASE_URL + HomeScreenBookings_api, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//       AppVersion: "12.15.0",
//       Language: "english",
//       DeviceId: "e9155efc-82e7-4125-8cc0-015267306249",
//       OsVersion: "11",
//       GuId: getGuId(),
//       ManufactureModel: "SM-M107F"
//     }),
//   });
//   if (response.ok) {
//     return await response.json();
//   } else {
//     throw new Error("Failed to fetch profile");
//   }
// };

// export const findColleagues = async () => {
//   if (!areTokensSet()) {
//     console.log("Tokens not found. Logging in...");
//     await Login(); // Wait for login to complete
//   }

//   const response = await fetchWithTokenRefresh(BASE_URL + SearchBookings_api, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//       AppVersion: "12.15.0",
//       SearchMemberId: 0,
//       Language: "english",
//       ZoneId: "",
//       DeviceId: "",
//       OsVersion: 10,
//       ManufactureModel: "Android SDK built for x86",
//       GuId: getGuId(),
//     }),
//   });
//   if (response.ok) {
//     console.log("Colleagues fetched");
//     return await response.json();
//   } else {
//     throw new Error("Failed to fetch profile");
//   }
// }

// export const employeeRole_api = async () => {
//   if (!areTokensSet()) {
//     console.log("Tokens not found. Logging in...");
//     await Login(); // Wait for login to complete
//   }

//   const response = await fetchWithTokenRefresh(BASE_URL + EmployeeRole_api, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//         AppVersion: "12.5.0",
//         EmployeeRoleId: 0,
//         Language: "english",
//         ZoneId: "",
//         DeviceId: "c81da199-9875-4bbf-9d12-411ffaa4c1ea",
//         OsVersion: "10",
//         GuId: getGuId(),
//         ManufactureModel: "Android SDK built for x86"
//     }),
//   });
//   if (response.ok) {
//     console.log("Colleagues fetched");
//     return await response.json();
//   } else {
//     throw new Error("Failed to fetch profile");
//   }
// }

// export const MyBookings_api_function = async () => {

//   const profileData = await fetchProfile();

//   if (!profileData) {
//     console.log("Profile data not found. Logging in...");
//   }
//   if (!areTokensSet()) {
//     console.log("Tokens not found. Logging in...");
//     await Login();
//   }

//   const response = await fetchWithTokenRefresh(BASE_URL + MyBookings_api, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//       ZoneId: profileData.Data.Records.ZoneId,
//       BookingDate: "", //if empty = Today Date
//       Language: "english",
//       ManufactureModel: "SM-M107F",
//       AppVersion: "12.15.0",
//       DeviceId: "c90d1fa3-e837-46e7-a5e2-15a9ad5ce21d",
//       GuId: getGuId(),
//       OsVersion: "11"
//     }),
//   });
//   if (response.ok) {
//     return await response.json();
//   } else {
//     throw new Error("Failed to fetch profile");
//   }
// };

// export const Calendar_API = async () => {

//   const profileData = await fetchProfile();

//   if(!profileData){
//     console.log("Profile data not found. Logging in...");
//   }
//   if (!areTokensSet()) {
//     console.log("Tokens not found. Logging in...");
//     await Login();
//   }

//   const response = await fetchWithTokenRefresh(BASE_URL + Calendar_api, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//         // ZoneId: 2562,
//         ZoneId: profileData.Data.Records.ZoneId,
//         GuId: getGuId(),
//         BookingStartDate: TodayDate,
//         Month: month,
//         Year: year,
    
//         TeamMemberGuId: "",
//         FilterStartTime: "",
//         DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f",
//         OsVersion: "10",
//         TagsFilter: "",
//         ManufactureModel: "Android SDK built for x86",
//         IsGuest: 0,
//         FuelFilter: "",
//         AppVersion: "12.15.0",
//         ShareableFilter: "",
//         Language: "english",
//         FilterEndTime: "",
//         VehicleTypeFilter: "",
//         IsFromAppHome: 0,
//         AccessibleFilter: "",
//         FacilityFilter: ""
//     }),
//   });
//   if (response.ok) {
//     return await response.json();
//   } else {
//     throw new Error("Failed to fetch profile");
//   }
// };
// // Initialize app
// const initializeApp = async () => {
//   try {
//     const profileResponse = await fetchProfile();
//     console.log("Profile fetched:", profileResponse);
//   } catch (error) {
//     console.error("Error:", error.message);
//   }
// };

// initializeApp();
